import { OssApi } from '../global/OssApi';
import { OssSceneValue } from '../global/OssConfig';

export class AliOssUtil {
  static async uploadFile(
    file: File,
    scene: OssSceneValue,
    onProgress?: (percent: number) => void,
  ): Promise<string> {
    const ext = file.name.split('.').pop() || 'jpg';
    const contentType = file.type || mimeOf(ext);

    const ticket = await OssApi.getUploadTicket({
      scene,
      ext,
      contentType,
    });
    if (!ticket?.uploadUrl || !ticket.accessUrl) {
      throw new Error('获取上传凭证失败');
    }

    const headers: Record<string, string> = {
      ...(ticket.headers || {}),
      'Content-Type': contentType,
    };

    if (onProgress) {
      await new Promise<void>((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open('PUT', ticket.uploadUrl, true);
        Object.entries(headers).forEach(([key, value]) => {
          xhr.setRequestHeader(key, value);
        });
        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable) {
            onProgress(Math.min(100, Math.round((event.loaded / event.total) * 100)));
          }
        };
        xhr.onload = () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            resolve();
          } else {
            reject(new Error(`文件上传失败: ${xhr.status}`));
          }
        };
        xhr.onerror = () => reject(new Error('文件上传失败'));
        xhr.send(file);
      });
    } else {
      const response = await fetch(ticket.uploadUrl, {
        method: 'PUT',
        headers,
        body: file,
      });
      if (!response.ok) {
        throw new Error(`文件上传失败: ${response.status}`);
      }
    }
    return ticket.accessUrl.split('?')[0];
  }
}

function mimeOf(ext: string): string {
  const value = ext.replace('.', '').toLowerCase();
  if (value === 'jpg' || value === 'jpeg') return 'image/jpeg';
  if (value === 'png') return 'image/png';
  if (value === 'gif') return 'image/gif';
  if (value === 'webp') return 'image/webp';
  if (value === 'mp4') return 'video/mp4';
  return 'application/octet-stream';
}
